
















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrency18AccountSignInIntroduction from './digital-currency-18-account-sign-in-introduction.vue'

@Component({
  components: {
    DigitalCurrency18AccountSignInIntroduction
  }
})
class DigitalCurrency15AccountSettingsButton extends Vue {
  @Prop({ default: false }) isIconButton?: boolean
  @Prop({ default: false }) isDepressedButton?: boolean
  @Prop({ default: '' }) accountId?: string

  isVisibleAccountSignInDialog: boolean = false

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.isVisibleAccountSignInDialog = isVisible
  }
}

export default DigitalCurrency15AccountSettingsButton

